import { useState } from 'react';
import { Share2, Check } from 'lucide-react';
import { toast } from 'sonner';

// Shares the crawler-friendly /api/public/share/... URL so LinkedIn/X/Slack render
// a tailored preview card. Falls back to copying the link when the Web Share API
// is unavailable (most desktop browsers).
export const ShareButton = ({ shareUrl, title, label = 'Share', testid = 'share-button', className }) => {
  const [copied, setCopied] = useState(false);

  const onShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, url: shareUrl });
        return;
      } catch (e) {
        if (e && e.name === 'AbortError') return;
      }
    }
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success('Share link copied - paste it anywhere');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Could not copy the link');
    }
  };

  return (
    <button
      type="button"
      onClick={onShare}
      data-testid={testid}
      className={className || 'inline-flex items-center justify-center gap-1.5 border border-[#E5E7EB] hover:border-[#00A79D] text-gray-800 font-semibold px-5 py-2.5 rounded-md transition-colors'}
    >
      {copied ? <Check className="w-4 h-4" /> : <Share2 className="w-4 h-4" />} {copied ? 'Copied' : label}
    </button>
  );
};
